<template>
  <sword-tag
    v-tooltip="'Gutenberg flow'"
    class="mr-1"
    color="black"
    size="sm"
  >
    G
  </sword-tag>
</template>

<script>
export default {
  name: 'GutenbergHighlight',
}
</script>
